import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useAddStandardException = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Something went wrong");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({
      staffMemberId,
      type,
      startTime,
      endTime,
      startAt,
      endAt,
      reason,
      allDay,
    }) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/schedule-exceptions/standard`,
        {
          staffMemberId: staffMemberId,
          type: type,
          startTime: startTime,
          endTime: endTime,
          startAt: startAt,
          endAt: endAt,
          isAllDay: allDay,
          reason: reason,
          allDay: allDay,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Standard exception added successfully!");
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      onSuccess?.();
    },
    meta: { skipGlobalError: true },
    onError: handleNetworkError,
  });
};
